import { Http } from './http';

class CropStateHttp extends Http {
  prefix = 'crop-state';

  async updateBulk(params: UpdateBulkParams): Promise<number> {
    const { data } = await this.put<number>('/update-bulk', params);

    return data;
  }
}

export const cropStateHttp = new CropStateHttp();

interface UpdateBulkParams {
  selectedIds: number[];
  prop: string;
  value: string | number | null;
}

